import { gaugeThemeColors } from '@/util/gaugeTheme';

// dipake widget canvas-gauges, biar plate/ticks/border ikut tema tanpa reload
export default {
  computed: {
    gaugeThemeResolved() {
      return this.$store.state.theme.resolved;
    },
  },
  watch: {
    gaugeThemeResolved(theme) {
      if (this.gaugeInstance) this.gaugeInstance.update(gaugeThemeColors(theme));
    },
  },
};
